/*
 * File: Account.tsx
 * Project: a-a
 * File Created: Saturday, 9th November 2024 9:48:32 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Wednesday, 1st April 2026 6:46:53 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2024 Mutual Mobile, Mutual Mobile
 */
import React, { useEffect, useState } from 'react';
import InfiniteScrollColumn from '../../InfiniteScrollColumn/InfiniteScrollColumn';
import { Box, Typography } from '@mui/material';
import zeplinColor from '../../../../theme/Color';
import CustomCard from '../../CustomCard/CustomCard';
import AccountCard from './AccountCard/AccountCard';
import { DashboardService } from '../../../../service/dashboard.service';
import styles from './AccountColumn.module.css';
const AccountColumn = ({
  setTabLoading,
  path,
}: {
  setTabLoading: React.Dispatch<React.SetStateAction<boolean>>;
  path?: string;
}) => {
  const screenHeight = window.innerHeight;
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<{ accounts: any[] }>({ accounts: [] });
  const getAccount = async () => {
    setLoading(true);
    try {
      //  const toolsQuery = selectedItems.tools.join(',');
      //  const timeQuery = selectedItems.time
      //    .map((val: string) => 'this' + val.toLocaleLowerCase())
      //    .join(',');

      const res = await DashboardService.getActionAccount();

      console.log({ res });
      if (res) {
        setData({ ...res });
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
      setTabLoading(false);
    }
  };
  // console.log(data);
  useEffect(() => {
    getAccount();
  }, []);
  const Header = () => {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          height: { xs: '34px', xl: '48px' },
        }}
      >
        <Typography variant='responsiveHeading3'>Actionable Accounts</Typography>
        {/* <Link
          to='https://login.salesforce.com/?locale=au'
          style={{ color: zeplinColor.BasicBlack, textDecoration: 'none' }}
        >
          <CustomCard
            styles={{
              borderRadius: '50px',
              padding: '10px 10px 10px 16px',
              backgroundColor: zeplinColor.Neutral1,
              border: `1px solid ${zeplinColor.Neutral6}`,
              display: 'flex',
              gap: '8px',
              // flexDirection: 'column',
              alignItems: 'flex-end',
              justifyContent: 'space-between',
              cursor: 'pointer',
            }}
          >
            <Typography variant='body3'>Salesforce</Typography>
            <img src='/assets/link-2.svg' width={20} height={20} />
          </CustomCard>
        </Link> */}
      </Box>
    );
  };
  const Column = () => {
    return (
      // <Box
      //   sx={{
      //     // flex: 1,
      //     // display: 'flex',
      //     // flexDirection: 'column',
      //     // justifyContent: 'center',
      //     // alignItems: 'center',
      //     overflowY: 'scroll',
      //   }}
      // >
      !data?.accounts?.length && !loading ? (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            height: { xs: '24vh', xl: '30vh' },
            // screenHeight > 1200
            //   ? '28vh'
            //   : screenHeight > 1100
            //   ? '27vh'
            //   : screenHeight > 1000
            //   ? '26vh'
            //   : screenHeight > 900
            //   ? '25vh'
            //   : screenHeight > 800
            //   ? '24vh'
            //   : '23vh',
          }}
        >
          {' '}
          <img src={'/assets/no-action-account.svg'} className={styles['no-account-icon']} />
          <Typography
            variant='responsiveHeading3'
            color={zeplinColor.BasicBlack}
            sx={{ marginTop: { xs: '22px', xl: '24px' } }}
          >
            No Actionable Accounts
          </Typography>
          <Typography
            variant='responsiveBody3'
            color={zeplinColor.Neutral8}
            sx={{ marginTop: { xs: '10px', xl: '12px' }, textAlign: 'center' }}
          >
            Great work! There’s nothing that needs your attention right now. Keep up the momentum!
          </Typography>
        </Box>
      ) : loading ? (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            height: { xs: '24vh', xl: '30vh' },
            overflowY: 'hidden',
            gap: { xs: '10px', xl: '16px' },
            // screenHeight > 1200
            //   ? '28vh'
            //   : screenHeight > 1100
            //   ? '27vh'
            //   : screenHeight > 1000
            //   ? '26vh'
            //   : screenHeight > 900
            //   ? '25vh'
            //   : screenHeight > 800
            //   ? '24vh'
            //   : '23vh',
          }}
        >
          {[1, 2, 3, 4, 5].map((val: any, ind: number) => (
            <AccountCard data={val} index={ind} key={ind} loading={true} />
          ))}
        </Box>
      ) : (
        <Box
          sx={{
            overflowY: 'scroll',
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            position: 'relative',
            // height: screenHeight > 640 ? '25vh' : screenHeight > 500 ? '12vh' : '10vh',
            height: { xs: '24vh', xl: '26vh' },

            gap: { xs: '10px', xl: '16px' },
            // screenHeight > 1200
            //   ? '28vh'
            //   : screenHeight > 1100
            //   ? '27vh'
            //   : screenHeight > 1000
            //   ? '16vh'
            //   : screenHeight > 900
            //   ? '25vh'
            //   : screenHeight > 800
            //   ? '24vh'
            //   : '23vh',
          }}
        >
          {data?.accounts?.map((val: any, ind: number) => (
            <AccountCard data={val} index={ind} key={ind} path={path || ''} />
          ))}
        </Box>
      )
      // </Box>
    );
  };

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: '0px',
        padding: '10px 16px 16px 16px',

        border: `1px solid ${zeplinColor.Neutral5}`,
        borderRadius: '14px',
      }}
    >
      <Header />
      <Column />
      {/* <Box>
        <Header />
      </Box> */}
      {/* <InfiniteScrollColumn header={<Header />} content={<Column />} height='25vh' /> */}
    </Box>
  );
};

export default AccountColumn;
